export const paymentGatewayEnum = Object.freeze({
    FREECHARGE: 'freecharge',
    PAYU: 'payu',
    CASHFREE: 'cashfree'
});

export const midNameEnum = Object.freeze({
    ID: "Mayank",
    NON_ID: "Vineet"
});